// QA Rules > Required Fields > "Treat '-', 'N/A' and similar placeholders as blank when leads are uploaded".
// Stored as required_fields config_json.blank_placeholders (backend app/utils/placeholders.py). On unless the
// saved config says exactly `false`, so every rule saved before this setting existed keeps blanking them.
export const placeholdersEnabled = (config) => !config || config.blank_placeholders !== false;

// The setting is always written as an explicit boolean: the effective rule (goal > component > program) governs
// as a whole, so a component's own rule must say what it means rather than rely on the program's.
export const withPlaceholderSetting = (config, enabled) => ({ ...config, blank_placeholders: !!enabled });

export const PLACEHOLDER_EXAMPLES = '"-", "--", "N/A", "null", "none", "unknown", "TBD"';
